export default __webpack_public_path__ + "static/media/delete-modal-icon.9554ccf2.svg";